
import Google_event from "app/tracking/google/event"
import FacebookPixel_event from "app/tracking/facebook-pixel/event"

const track = ($el: JQuery) => {
  if (is_high_value_search($el.data("price"))){
    Google_event.track({
      category: "Remarketing",
      action:   "User Interested In >50m Properties",
    })

    FacebookPixel_event.track({
      category: "Remarketing",
      name:     "User Interested In >50m Properties",
    })
  }
}

function is_high_value_search(price: string | null | undefined) {
  return (price != null && parseFloat(price) >= 50000000)
}

export default {track}
